export default "__VITE_ASSET__7ccdb075__"